// extracted by mini-css-extract-plugin
export var container = "_4p-1";
export var cornerButtonContainer = "_4p-5";
export var disabled = "_4p-2";
export var fileContainer = "_4p-4";
export var hiddenInput = "_4p-3";
export var widthContainer = "_4p-0";